export const AUTOSAVE_DEBOUNCE_MS = 2000;

export const RETRY_BACKOFF_MS = [1000, 2000, 4000] as const;

export const SAVED_INDICATOR_FADE_MS = 4000;

export const RELATIVE_TIME_REFRESH_MS = 30_000;

export const LOCAL_STORAGE_SCHEMA_VERSION = 3 as const;
